import React from 'react';
import { IconName } from '../IconNameEnum';
import { IconStatus } from '../IconEnum';
import { has, is } from '../../../services/index';
import clsx from 'clsx';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
const StatusIcon = ({ className, name, status, statusPosition, size, testId }) => {
    const { styled } = useTrilogyContext();
    const ancestorClasses = hashClass(styled, clsx('icon', size && is(`${size}`), is('ancestor'), has('status'), className));
    const descendantClasses = hashClass(styled, clsx('icon is-circled is-descendant', status && is(`${status}`), statusPosition && is(`${statusPosition}`)));
    const descendantIcon = hashClass(styled, clsx(status === IconStatus.SUCCESS ?
        IconName.CHECK_CIRCLE :
        IconName.TIMES_CIRCLE));
    return (React.createElement("span", { className: ancestorClasses, "aria-hidden": 'true', "data-testid": testId },
        React.createElement("span", { className: hashClass(styled, clsx(name)) }),
        React.createElement("span", { className: descendantClasses },
            React.createElement("i", { className: descendantIcon }))));
};
export default StatusIcon;
//# sourceMappingURL=StatusIcon.js.map